import { render, staticRenderFns } from "./SettingsSetTerm.vue?vue&type=template&id=681f72da"
import script from "./SettingsSetTerm.vue?vue&type=script&lang=js"
export * from "./SettingsSetTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports